import React, { FC, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Popup from "reactjs-popup";
import apiCalls from "../PowerShadesAPIFunctions";
import Button from "../Parts/Button";
import { useIsPowerShadesAdmin } from "../hooks";
import { useQuoteTypeNameByQuoteId } from "../Store/entities/quotes/hooks";
import { UsePortalDispatch } from "../Store";
import { wentToQuote } from "../Store/entities/quotes";
import { reloadAssembliesById } from "../Store/entities/assemblies";
import { toast } from "react-toastify";

type ShadeImportProps = {
	quoteId: number;
};

type ShadeImportAllowedFileTypes = "xlsx" | "csv";

const ShadeImport: FC<ShadeImportProps> = ({ quoteId }) => {
	const [shadeImportOpen, setShadeImportOpen] = useState(false);

	const [currentFile, setCurrentFile] = useState<File>();
	const [fileType, setFileType] = useState<ShadeImportAllowedFileTypes>("csv");
	const [shadeType, setShadeType] = useState<"single" | "dual" | "coupled" | "dual_coupled">("single");
	const [isInsertNotUpdating, setIsInsertNotUpdating] = useState(false);

	// Temporary gate until the feature has been vetted.
	const isPsAdmin = useIsPowerShadesAdmin();


	const dispatch = UsePortalDispatch();


	const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { files } = event.target;
		const selectedFiles = files as FileList;
		setCurrentFile(selectedFiles?.[0]);
	};

	const handleFileImport = () => {
		if (currentFile) {
			dispatch(wentToQuote(quoteId));
			apiCalls.importQuoteShades(quoteId, currentFile, shadeType, isInsertNotUpdating ? 'insert' : 'update').then((response) => {
				if (response.success) {
					setShadeImportOpen(false);
					dispatch(reloadAssembliesById({
						quoteId
					}));
					toast.success("Shades Imported Successfully");
				} else {
					toast.error("Importing Shades Failed with error: " + response.error);
				}

			});
		}
	};

	const handleFileExport = () => {
		// Call the API to export the shades in current file type.
		apiCalls.getExportedQuoteShades(quoteId, fileType, shadeType).then((_response) => {
			setShadeImportOpen(false);
		});
	};

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	return (
		<>
			{
				(
					isPsAdmin && <Button
						fullWidth
						onClick={() => setShadeImportOpen(true)}
						color={quoteType}
					>
						Shade Import
					</Button>
				)}
			<Popup
				open={shadeImportOpen}
				onClose={() => setShadeImportOpen(false)}
				modal
				className="mobile-modal"
			>
				<Row>
					<Col>
						<Row>
							<Col>
								<Row>
									<label>File Type</label>
								</Row>
								<Row>
									<Form.Select
										value={shadeType}
										onChange={(e) => setShadeType(e.target.value as "single" | "dual" | "coupled" | "dual_coupled")}
									>
										<option value="single">Single</option>
										<option value="dual">Dual</option>
										<option disabled title="Coming Soon" value="coupled">Coupled</option>
										<option disabled title="Coming Soon" value="dual_coupled">Dual Coupled</option>
									</Form.Select>
								</Row>
								<Row>
									<Form.Select
										value={fileType}
										onChange={(e) => setFileType(e.target.value as ShadeImportAllowedFileTypes)}
									>
										<option disabled title="Coming Soon" value="xlsx">Excel</option>
										<option value="csv">CSV</option>
									</Form.Select>
								</Row>
								<Row>
									<Form.Check
										type="checkbox"
										label="Insert New Shades Only (uncheck to update existing shades)"
										title="Coming Soon"
										checked={isInsertNotUpdating}
										onChange={() => setIsInsertNotUpdating(!isInsertNotUpdating)}
										disabled={true}
									/>
								</Row>

							</Col>
						</Row>
						<Row>
							<h2>Shade Import</h2>
							<Button disabled={!currentFile} onClick={() => handleFileImport()}>
								Import
							</Button>

						</Row>
						<Row>
							<Col>
								<Row>
									<h2>Shade Export</h2>

								</Row>
								<Row>
									<Button onClick={() => handleFileExport()}>
										Export
									</Button>
								</Row>
							</Col>

							<Col>
								<Row>
									<label className="btn btn-default p-0">
										<input type="file" onChange={handleFileUpload} />
									</label>
								</Row>

							</Col>
						</Row>
					</Col>
				</Row>
			</Popup>
		</>

	);
};

export default ShadeImport;
